<template>
  <div class='wing-layout'>
    <div class='main-wrap'>
      <div id='main-content'>
        <div class='wrapper'>
          <jm-crumbs :crm_id="this.$route.params.id"/>
          <div
            class='tab-card-wappers'
            v-loading.body="loading">
            <div class='title'><span>标题：</span>
              <el-input
                v-model="upload.title"
                placeholder="请输入内容"/>
            </div>
            <el-tabs
              class="el1"
              type="border-card"
              v-model='activeName1'
              @tab-click="handleClick">
              <el-tab-pane
                v-for='(item,key,index) in upload.schedule'
                :key='key'
                :label='item.year'
                :name='index'>
                <el-tabs
                  class="el2"
                  v-model='activeName2'
                  @tab-click="clicktab"
                  id="mubiao">
                  <el-tab-pane
                    v-for='(itemA,keyA,indexA) in item.labelList'
                    :key='keyA'
                    :label='itemA.name'
                    :name='indexA'>
                    <div
                      class="mounth-group"
                      v-for='(itemB,indexB) in itemA.month'
                      :key="indexB"
                    >
                      <div class="group">
                        <el-checkbox
                          class="ipt-check"
                          v-model='itemB.show'>显示给学生</el-checkbox>
                        <el-radio-group v-model='itemB.level'>
                          <el-radio :label='3'>高</el-radio>
                          <el-radio :label='2'>中</el-radio>
                          <el-radio :label='1'>低</el-radio>
                        </el-radio-group>
                      </div>
                      <div class="group mounths">
                        <span>{{ itemB.name }}：</span>
                        <el-input
                          type='textarea'
                          :rows='2'
                          placeholder='请输入内容'
                          v-model='itemB.content'/>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </el-tab-pane>
            </el-tabs>
            <!--推荐院校-->
            <div class="recommend-wapper">
              <p>推荐院校:</p>
              <div
                class="recommend"
                v-for="(item,index,key) in recommend"
                :key="key"
                :index="index">
                <p>申请学校{{ index+1 }}</p>
                <div class="ipt-wapper">
                  <div class="ipt">
                    <span>*学校中文名:</span>
                    <jm-school-search
                      clearable
                      :country-id="485"
                      v-model="recommend[index]"/>
                    <span class="name-en">*学校英文名:</span>
                    <span>{{ item.sh_name_en }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!--推荐院校end 按钮开始-->
            <div class="btn-group">
              <el-button
                type="success"
                @click="save">保存</el-button>
              <el-button
                type="primary"
                @click="secretKey"
                v-if="text === ''">生成密钥图片</el-button>
              <div
                class="img-ipt"
                v-if="text !== ''">
                <a
                  :href="imgSrc"
                  :download="upload.title"
                  id="down">下载密钥图片</a>
                <textarea
                  id="contents"
                  rows="10"
                  cols="10"
                  style="height:0;width:0;opacity: 0;"/>
                <el-button
                  type="warning"
                  @click="cloneText">复制密钥文本</el-button>
              </div>
            </div>
          </div>
          <div
            id="float"
            class="float"
            v-if="imgSrc !== ''">
            <img :src="imgSrc" >
          </div>
          <transition
            v-if="show"
            name="fade">
            <div class="prompting-wapper">
              <div class="prompting">
                <p>当前录入位置:{{ years }}年</p>
                <P>{{ labels }}</P>
              </div>
              <div
                class="back"
                @click="goTop">
                <p>返回</p>
                <p>顶部</p>
              </div>
            </div>
          </transition >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import { jmSchoolSearch } from '@/components/tool';


export default {
  data() {
    return {
      student: {},
      recommend: [],
      activeName1: '0',
      activeName2: '0',
      schoolObj: {},
      countryId: 485,
      clearable: false,
      crmid: this.$route.params.id,
      onschool: {
        sh_id: '',
        sh_name_cn: '',
        sh_name_en: '',
      },
      upload: {},
      loading: true,
      imgSrc: '',
      text: '',
      years: '',
      labels: '',
      show: false
    };
  },
  methods: {
    handleClick(val) {
      this.years = val.label;
      this.activeName2 = '0';
      this.labels = this.upload.schedule[Number(this.activeName1)].labelList[0].name;
    },
    clicktab(val) {
      this.labels = val.label;
    },
    getData() {
      // 请求学生数据
      this.$http._get({
        url: `index/school_schedule/schedule/crmid/${this.crmid}`,
      }).then((data) => {
        let schoolNum = 5 - data.data.schools.length;
        for (let i = 0; i < schoolNum; i++) {
          data.data.schools.push(this.onschool);
        }
        this.years = data.data.schedule[0].year;
        this.labels = data.data.schedule[0].labelList[0].name;
        this.upload = data.data;
        this.recommend = data.data.schools;
        this.loading = false;
        if (data.data.keyInfo.keyCode !== false) {
          this.imgSrc = `/newfib.php/index/school_schedule/pickey/crmid/${this.crmid}`;
          this.text = data.data.keyInfo.keyCode;
          setTimeout(() => {
            let Img = document.getElementById('float');
            Img.style.display = 'none';
          }, 2000);
        }
      }).catch(() => {
      });
    },
    save() {
      this.$http._post({
        url: `index/school_schedule/save/crmid/${this.crmid}`,
        data: { ...this.upload }
      }).then(() => {
        this.$message.success('保存成功');
      });
    },
    secretKey() {
      this.$http._post({
        url: `index/school_schedule/genkey/crmid/${this.crmid}`,
      }).then((data) => {
        if (data.data !== '') {
          let keyImage = `/newfib.php/index/school_schedule/pickey/crmid/${this.crmid}`;
          this.imgSrc = keyImage;
          setTimeout(() => {
            let Img = document.getElementById('float');
            Img.style.display = 'none';
          }, 2000);
          this.text = data.data.keyCode;
        } else {
          this.$message.error('生成失败');
        }
      });
    },
    cloneText() {
      let e = document.getElementById('contents');
      e.value = this.text;
      e.select();
      document.execCommand('Copy');
      this.$message.success('复制成功');
    },
    handleScroll() {
      let obj = document.getElementById('mubiao');
      let top = obj.getBoundingClientRect().top;
      this.show = window.scrollY > top;
    },
    goTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  },
  mounted() {
    this.getData();
    window.addEventListener('scroll', this.handleScroll);
  },
  components: {
    'jm-crumbs': crumbs, // 面包屑
    jmSchoolSearch,
  },
  watch: {
    recommend(value) {
      value.forEach((item, index) => {
        if (item === null) {
          this.recommend[index] = this.onschool;
        } else {
          this.recommend[index] = {
            sh_id: item.sh_id,
            sh_name_cn: item.sh_name_cn,
            sh_name_en: item.sh_name_en,
          };
        }
      });
      this.upload.schools = this.recommend;
    },
  }
};
</script>
<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in below version 2.1.8 */ {
  opacity: 0
}
.back{
  width: 40px;
  font-size: 12px;
  float: right;
  margin-top: 10px;
  background: #20a0ff;
  text-align: center;
  color: #fff;
  padding: 5px 0;
  border-radius: 100%;
  cursor: pointer;
}
.prompting-wapper{
  position: fixed;
  right:0;
  top:200px;
}
.prompting{
  background: #20a0ff;
  padding: 5px 0 5px 15px;
  border-top-left-radius:50px;
  border-bottom-left-radius: 50px;
}
.prompting>p{
  color: #fff;
  width: 260px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.img-ipt>a{
  float: left;
  display: block;
  width: 110px;
  height:36px;
  text-align: center;
  line-height: 36px;
  color: #fff;
  background: #2196f3;
  border-radius: 4px;
  margin-right: 40px;
}
.float{
  width: 500px;
  height: 500px;
  position: fixed;
  left:50%;
  top:50%;
  margin-left: -250px;
  margin-top: -250px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}
.float img{
  width: 100%;
}
.title{
  border-bottom: 1px solid #000;
  font-size: 18px;
  padding-bottom: 4px;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
}
.title span{
  font-weight: 700;
  font-size: 30px;
  white-space: nowrap;
}
.mounth-group{
  padding-bottom: 12px;
}

.mounth-group .group{
  margin-bottom: 10px;
}
.mounths{
  display: flex;
}
.mounths span{
  white-space: nowrap;
  margin-right: 6px;
  font-family: Arial;
}
.el1{
  margin-bottom: 15px;
}
.recommend-wapper>p{
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 10px;
}
.recommend{
  border: 1px solid #000;
  margin-bottom: 10px;
}
.recommend>p{
  font-size: 16px;
  background: #01142d;
  color: #fff;
}
.ipt-wapper{
  display: flex;
  padding: 15px 0;
}
.ipt{
  display: flex;
  align-items: center;
}
.ipt-wapper .ipt:nth-of-type(1){
  margin-left: 10px;
}
.ipt-wapper .ipt:nth-of-type(2){
  margin-left: 10px;
}
.ipt span{
  white-space: nowrap;
  margin-right: 5px;
}
.ipt-check{
  margin-right: 10px;
}
.btn-group{
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
.btn-group>button:nth-of-type(1){
  margin-right: 40px;
}
.name-en{
  margin-left: 15px;
}
.activeTime {
  position: relative;
  padding-top: 137px;
}
</style>
<style>
</style>
